/**
 * moduł trzymający informacje o validacji
	*@module validate
*/
app.service('validate', function(front,ajaxForm, passwordInvalid){
	var rules={
		email:{
			required:true,
			email: true,
			maxlength: 200
		},
		email2:{
			email:true
		},
		emailRepeat:{
			required:true,
			email:true,
			equalTo: "#email"
		},
		recaptcha: {
			required: true
		},
		passwordOld:{
			required:true
		},
		login:{
			required:true
		},
		password:{
			required:true,
			minlength: 5
		},
		strongPassword: {
			strongPassword: true
		},
		passwordNewRepeat: {
			required:true,
			equalTo: "#password"
		},
		firstname:{
			required: true,
			minlength: 2,
			firstname: true
		},
		surname:{
			required: true,
			minlength: 2,
			surname: true
		},
		userType:{
			required:true
		},
		zipCode:{
			required:true,
			zipCode:true
		},
		phone:{
			required: true,
			phone:true
		},
		notRequiredPhone:{
			required: false,
			phone:true
		},
		city:{
			required: true,
			minlength: 2,
			maxlength: 40,
			city: true
		},
		street:{
			required: true,
			minlength: 2,
			maxlength: 60,
			street: true
		},
		nip:{
			required:true,
			nip:true
		},
		companyName:{
			required: true,
			maxlength: 160,
			companyName: true
		},
		houseNumber:{
			required:true,
			maxlength: 10,
			houseNumber: true
		},
		flat:{
			maxlength: 10,
			flat: true
		},
		termsAccepted:{
			required:true
		},
		legalStatement: {
			required: true
		},
		pesel:{
			required:true,
			pesel:true
		},
		warrantyRegulations:{
			required:true
		},
		warrantySubscriptionRegulations:{
			required:true
		},
		shopCode:{
			required: true,
			minlength:2
		},
		cityCode:{
			required: true,
			min: 1,
		},
		parcelMachineCode:{
			required: true
		},
		postOfficeCode:{
			required: true
		},
		pofficeZipCode: {
			zipCode: true
		},
		postCityCode:{
			required: false
		},
		messageTextarea:{
			required: true
		},
		parcelMachineCity:{
			required: true
		},
		ePaymentBank:{
			required: true
			// required: "#row3:checked"
		},
		birthday:{
			required:true,
			birthday:true
		},
		interestsCount:{
			required: true,
			min:1
		},
		favouriteCategoriesCount:{
			required: true,
			min:1
		},
		cancelReason:{
			required:true
		},
		cancelReasonOther: {
			required: function(element){
				return $("#cancel-reason option:last").is(":selected");
			}
		},
		nick:{
			required: true,
			maxlength: 200
		},
		nick2:{
			required: true,
			minlength: 3,
			maxlength: 64,
			userNick: true
		},
		shortOpinion:{
			required: true,
			maxlength: 200
		},
		opinion:{
			required:true,
			minlength: 20,
			maxlength: 5000
		},
		paymentType:{
			required: true
		},
		deliveryType:{
			required: true
		},
		deliveryTimeGroup:{
			required: true
		},
		interval:{
			required: true
		},
		deliveryCostAccepted:{
			required: true
		},
		notice:{
			required:true,
			email:true
		},
		questionEdit:{
			required:true,
			minlength:3
		},
		answerEdit:{
			required:true,
			minlength:3
		},
		complaintReason:{
			required:true
		},
		complaintDescription:{
			required:true
		},
		giftCardNumber:{
			required: true,
			digits:true,
			minlength:21,
			maxlength:21
		},
		giftCardPin:{
			required: true,
			digits:true,
			minlength:4,
			maxlength:4
		},
		voucherCode:{
			voucherCode: true
		},
		captcha:{
			required: true
		}
	};
	var messages={
		firstname:{
			required:"Podaj imię",
			minlength: "Imię jest za krótkie"
		},
		surname:{
			required:"Podaj nazwisko",
			minlength: "Nazwisko jest za krótkie"
		},
		userType:{
			required:"Wybierz sposób zakupów"
		},
		zipCode:{
			required:"Podaj kod pocztowy"
		},
		city:{
			required: "Podaj miejscowość",
			minlength: "Miasto jest za krótkie",
			maxlength: "Pole może zawierać maksymalnie 40 znaków"
		},
		phone:{
			required:"Podaj numer telefonu"
		},
		street:{
			required: "Podaj ulicę",
			minlength: "Ulica jest za krótka",
			maxlength: "Pole może zawierać maksymalnie 60 znaków"
		},
		companyName:{
			required: "Podaj nazwę firmy",
			maxlength: "Pole może zawierać maksymalnie 160 znaków"
		},
		nip:{
			required:"Podaj NIP"
		},
		houseNumber:{
			required: "Podaj numer domu",
			maxlength: "Pole może zawierać maksymalnie 10 znaków"
		},
		flat:{
			maxlength: "Pole może zawierać maksymalnie 10 znaków",
			flat: "Uzupełnij pole poprawnie"
		},
		password:{
			required:"Podaj hasło",
			minlength: "Hasło ma minimum {0} znaków"
		},
		login:{
			required:"Podaj login"
		},
		passwordOld:{
			required:"Podaj swoje hasło"
		},
		passwordNewRepeat: {
			required:"Powtórz hasło",
			equalTo: "Hasła muszą być identyczne"
		},
		email:{
			required: "Wpisz adres e-mail",
			email: "Wpisz poprawny adres e-mail",
			maxlength: "Podany adres e-mail jest za długi"
		},
		email2:{
			email:"Podaj poprawnego e-maila albo pozostaw pole puste"
		},
		emailRepeat:{
			required:"Powtórz adres e-mail",
			email:"Powtórz poprawny adres e-mail",
			equalTo: "Podane adresy nie są identyczne"
		},
		recaptcha: {
			required: "Prosimy zaznacz nie jestem robotem"
		},
		termsAccepted:{
			required:"Akceptacja Regulaminu jest wymagana"
		},
		legalStatement:{
			required: "Akceptacja oświadczenia jest wymagana"
		},
		pesel:{
			required:"Podaj numer PESEL"
		},
		warrantyRegulations:{
			required:"Zapoznaj sie z warunkami ubezpieczenia"
		},
		warrantySubscriptionRegulations:{
			required:"Zapoznaj się z Regulaminem płatności cyklicznej"
		},
		shopCode:{
			required: front.euro ? "Wybierz sklep, w którym chcesz odebrać Towary" : "Wybierz punkt odbioru, w którym chcesz odebrać Towary",
			minlength: front.euro ? "Wybierz sklep, w którym chcesz odebrać Towary" : "Wybierz punkt odbioru, w którym chcesz odebrać Towary"
		},
		cityCode:{
			required: "Wybierz miejscowość, w której chcesz odebrać Towary",
			min: "Wybierz miejscowość, w której chcesz odebrać Towary"
		},
		parcelMachineCode:{
			required: "Wybierz Paczkomat®"
		},
		dhlParcelPointCode:{
			required: "Wybierz punkt odbioru "
		},
		postOfficeCode:{
			required: "Wybierz punkt odbioru "
		},
		messageTextarea:{
			required: "Wiadomość nie może być pusta"
		},
		parcelMachineCity:{
			required: "Wybierz miejscowość, w której chcesz odebrać Towary"
		},
		ePaymentBank:{
			required: "Wybierz bank, w którym posiadasz internetowe konto osobiste"
		},
		birthday:{
			required:"Podaj datę urodzin"
		},
		interestsCount: {
			min:"Wybierz minimum jedną opcję"
		},
		favouriteCategoriesCount: {
			min:"Wybierz minimum jedną opcję"
		},
		cancelReason:{
			required:"Podaj przyczynę anulowania"
		},
		nick:{
			required: "Podaj nick",
			maxlength: "Podany nick jest za długi"
		},
		nick2:{
			required: 'Podaj nick',
			minlength: 'Podany nick jest za krótki (min. {0} znaki)',
			maxlength: 'Podany nick jest za długi (max. {0} znaki)'
		},
		shortOpinion:{
			required: "Podaj tytuł Opinii",
			maxlength: "Podany tytuł jest za długi"
		},
		opinion:{
			required : "Podaj treść Opinii",
			minlength: "Podana treść jest za krótka",
			maxlength: "Podana treść jest za długa"
		},
		paymentType:{
			required:"Wybierz rodzaj płatności"
		},
		deliveryType:{
			required: "Wybierz sposób zakupu"
		},
		deliveryTimeGroup:{
			required: "Wybierz termin dostawy"
		},
		deliveryCostAccepted:{
			required: "Przed potwierdzeniem Zamówienia/rezerwacji zaakceptuj koszty dostawy"
		},
		notice:{
			required:"Wpisz adres e-mail",
			email:"Wpisz poprawny adres e-mail"
		},
		questionEdit:{
			required:"Podaj treść pytania",
			minlength:"Pole powinno zawierać conajmniej 3 znaki"
		},
		answerEdit:{
			required:"Podaj treść odpowiedzi",
			minlength:"Pole powinno zawierać conajmniej 3 znaki"
		},
		complaintReason:{
			required: "Wybierz powód reklamacji"
		},
		complaintDescription:{
			required: "Opis nie może być pusty"
		},
		giftCardNumber:{
			required: "Wprowadź numer i PIN Karty Podarunkowej",
			digits:"Wprowadzony numer zawiera niedozwolone znaki",
			minlength:"Podaj poprawny numer Karty Podarunkowej (21 cyfr)",
			maxlength:"Podaj poprawny numer Karty Podarunkowej (21 cyfr)"
		},
		giftCardPin:{
			required: "Wprowadź numer i PIN Karty Podarunkowej",
			digits:"Wprowadzony PIN zawiera niedozwolone znaki",
			minlength:"Podaj poprawny pin Karty Podarunkowej (4 cyfry)",
			maxlength:"Podaj poprawny pin Karty Podarunkowej (4 cyfry)"
		},
		voucherCode:{
			voucherCode: "Kod rabatowy zawieran niedozwolone znaki"
		},
		captcha:{
			required: "Przepisz tekst z obrazka"
		}
	};
	var defaults={
		ignore:".ignore",
		success:function(label){
			label.closest('.validate-error').addClass('validate-ok').removeClass('validate-error');
			label.remove();
		},
		invalidHandler: function(form, validator) {
			if(!$(form.target).closest('.remodal-wrapper').length){		//jeśli bład występuje na warstwie to nie przesuwamy
				var $elementToScroll = $(validator.errorList[0].element).parent();
				if($elementToScroll.length){
					var topHeight = $elementToScroll.offset().top + $elementToScroll.height();
					var bottomHeight = $elementToScroll.offset().top;
					//console.log(topHeight , "<", window.scrollY, ' || ', bottomHeight, ' > ', window.scrollY + window.innerHeight)
					if(topHeight < window.scrollY || bottomHeight > window.scrollY + window.innerHeight){
						$.scrollTo($elementToScroll);
					}
				}
			}
		},
		errorPlacement: function (error, element) {
			var $radioGroup = element.closest('.radio-group');
			var $validateTarget = element.closest('.validate-target');
			if (element.attr('type')=='radio' && $radioGroup.length) {
				$radioGroup.addClass('validate-error').removeClass('validate-ok');
				$radioGroup.append(error);
			} else if ($validateTarget.length) {
				$validateTarget.addClass('validate-error').removeClass('validate-ok');
				$validateTarget.append(error);
			} else {
				error.insertAfter(element);
			}
		}
	};

	function scrollToError($validateTarget){
		var $box = $validateTarget || $('body').find('.error').eq(0).closest('.validate-target');
		if ($box.length) {
			$.scrollTo($box,0);
		}
	}

	function invalidHandler2(form, validator) {
		scrollToError($(validator.errorList[0].element).closest('.validate-target'));
	}

	function showErrors(){
		this.defaultShowErrors();
	}

	function errorPlacement2(error, element) {
		var $radioGroup = element.closest('.radio-group');
		var $validateTarget = element.closest('.validate-target');

		if (element.attr('type')=='radio' && $radioGroup.length) {
			$radioGroup.addClass('validate-error').removeClass('validate-ok');
			$radioGroup.append(error);
		} else if ( element.is(':checkbox') ) {
			$validateTarget.addClass('validate-error').removeClass('validate-ok');
			$validateTarget.append(error);
		} else if ($validateTarget.length) {
			$validateTarget.addClass('validate-error').removeClass('validate-ok');
			$validateTarget.append(error);
		} else {
			error.insertAfter(element);
		}
	}

	function setOptions(options){
		var obj={};
		for(var i in defaults) {
			obj[i] = defaults[i];
		}
		return $.extend(true,obj,options);
	}
	var tasks={
		warrantyUpsellingForm({ $form, submitHandler }) {
			const options = setOptions({
				submitHandler: submitHandler,
				rules: {
					"acceptance-1": {
						required: true
					},
					"acceptance-2": {
						required: true
					},
					"pesel": rules.pesel
				},
				messages: {
					"acceptance-1": {
						required: "Zapoznaj sie z warunkami ubezpieczenia"
					},
					"acceptance-2": {
						required: "Zapoznaj się z Regulaminem płatności cyklicznej"
					},
					"pesel": messages.pesel
				}
			});
			$form.validate(options);
		},
		warrantyUpsellingPaymentForm({ $form, submitHandler }) {
			const options = setOptions({
				submitHandler: submitHandler,
				rules: {
					"agreement": rules.warrantyRegulations
				},
				messages: {
					"agreement": messages.warrantyRegulations
				}
			});
			$form.validate(options);
		},
		subscriptionServiceInvoiceDataForm: function(props) {
			const { $form, onValidInvoiceData } = props;
			const options = setOptions({
				submitHandler: onValidInvoiceData,
				rules: {
					"firstName": rules.firstname,
					"lastName": rules.surname,
					"zipCode": rules.zipCode,
					"city": rules.city,
					"street": rules.street,
					"flatNumber": rules.flat,
					"houseNumber": rules.houseNumber,
					"nip": rules.nip,
					"companyName": rules.companyName
				},
				messages: {
					"firstName": messages.firstname,
					"lastName": messages.surname,
					"zipCode": messages.zipCode,
					"city": messages.city,
					"street": messages.street,
					"flatNumber": messages.flat,
					"houseNumber": messages.houseNumber,
					"nip": messages.nip,
					"companyName": messages.companyName
				}
			});
			$form.validate(options);
		},
		errorForm:function(sendFunction){
			var options=setOptions({
				submitHandler: function(form) {
					if($(form).valid()){
						sendFunction();
					}
				},
				rules:{
					"description": rules.messageTextarea,
					"email": {
						email: true,
						required: () => $("#error-subject").val() !== 'CONTENT_VIOLATION_ERROR'
					},
					"legalStatementSelected": rules.legalStatement,
					"g-recaptcha-response": rules.recaptcha
				},
				messages:{
					"description": messages.messageTextarea,
					"email": {
						email: "Podaj poprawny adres e-mail",
						required: "Wpisz adres e-mail"
					},
					"legalStatementSelected": messages.legalStatement,
					"g-recaptcha-response": messages.recaptcha
				}
			});
			$("#error-form").validate(options);
		},
		editNick:function(params){
			var form=params.form;
			var options=setOptions({
				rules:{
					"nick": rules.nick2
				},
				messages:{
					"nick": messages.nick2
				}
			});
			form.validate(options);
		},
		opinion:function(sendFunction){
			var form=$("#add-opinion-form form");
			var options=setOptions({
				submitHandler: function() {
					sendFunction();
				},
				rules:{
					"shortOpinion": rules.shortOpinion,
					"attributeGrade": {
						min:$("#opinion-form-grades .js-attribute-grade").length ? 0 : 1
					},
					"opinion": rules.opinion,
					"nick": rules.nick,
					"email": rules.email,
					"opinionStars": {
						min:$("#opinion-form-grades .js-attribute-grade").length
					},
					"opinionTermsAccepted": {
						required: true
					}
				},
				messages:{
					"shortOpinion": messages.shortOpinion,
					"attributeGrade": {
						min:"Zaznacz ocenę Towaru"
					},
					"opinion": messages.opinion,
					"nick": messages.nick,
					"email": messages.email,
					"opinionStars": {
						min:"Zaznacz ocenę Towaru"
					},
					"opinionTermsAccepted": {
						required: "Akceptacja regulaminu jest wymagana"
					}
				}
			});
			form.validate(options);
		},
		emptySearchResultsContactForm(callback) {
			let $form = $('#contact-form');
			const options = setOptions({
				submitHandler() {
					callback($form);
				},
				rules: {
					"contact-form-message": {
						required: true
					},
					"g-recaptcha-response": rules.recaptcha
				},
				messages: {
					"g-recaptcha-response": messages.recaptcha
				}
			});
			$form.validate(options);
		},
		availabilityNotificationForm: function (params) {
			const form = params.form;
			const options = setOptions({
				submitHandler: function () {
					params.callback();
				},
				rules: {
					"email": rules.email,
					"g-recaptcha-response": rules.recaptcha
				},
				messages: {
					"email": messages.email,
					"g-recaptcha-response": messages.recaptcha
				}
			});
			form.validate(options);
		},
		articleVoteUpForm: function(sendFunction) {
			var form = $('#article-vote-up-form');
			var options = setOptions({
				submitHandler: function(form) {
					sendFunction($(form));
				},
				rules: {
					"content": {
						required: true
					},
					"email": {
						required: function(){
							return $('#vote-up-email-agreement', form).is(':checked');
						},
						email: true
					},
					"g-recaptcha-response": rules.recaptcha
				},
				messages: {
					"content": {
						required: "Wpisz treść wiadomości"
					},
					"email": {
						required: "Wpisz adres e-mail",
						email: "Wpisz poprawny adres e-mail"
					},
					"g-recaptcha-response": messages.recaptcha
				}
			});
			form.validate(options);
		},
		articleVoteDownForm: function(sendFunction) {
			var form = $('#article-vote-down-form');
			var options = setOptions({
				submitHandler: function(form) {
					sendFunction($(form));
				},
				rules: {
					"reason": {
						required: true
					},
					"email": {
						required: function(){
							return $('#vote-down-email-agreement', form).is(':checked');
						},
						email: true
					},
					"g-recaptcha-response": rules.recaptcha
				},
				messages: {
					"reason": {
						required: "Wybierz jedną z opcji",
					},
					"email": {
						required: "Wpisz adres e-mail",
						email: "Wpisz poprawny adres e-mail"
					},
					"g-recaptcha-response": messages.recaptcha
				}
			});
			form.validate(options);
		},
		articleAdviceForm: function(sendFunction) {
			var form = $('#article-advice-form');
			var options = setOptions({
				submitHandler: function(form) {
					sendFunction($(form));
				},
				rules: {
					"topic": {
						required: true
					},
					"content": {
						required: true
					},
					"email": {
						email: true
					},
					"g-recaptcha-response": rules.recaptcha
				},
				messages: {
					"topic": {
						required: "Wpisz temat"
					},
					"content": {
						required: "Wpisz treść wiadomości"
					},
					"g-recaptcha-response": messages.recaptcha
				}
			});
			form.validate(options);
		},
		editDefinition: function(settings) {
			var form = $('#dictionary-edit-form');
			var options = setOptions({
				submitHandler: function(form) {
					settings.submit(form);
				},
				rules: {
					content: {
						required: true
					},
					"g-recaptcha-response": rules.recaptcha
				},
				messages: {
					content: {
						required: "Pole jest wymagane"
					},
					"g-recaptcha-response": messages.recaptcha
				}
			});
			form.validate(options);
		},
		notice:function(sendFunction){
			var form=$("#notice-form");
			var options=setOptions({
				submitHandler: function() {
					sendFunction(form);
				},
				rules:{
					notice:rules.notice,
					"g-recaptcha-response": rules.recaptcha
				},
				messages:{
					notice:messages.notice,
					"g-recaptcha-response": messages.recaptcha
				}
			});
			form.validate(options);
		},
		question:function(sendFunction){
			var form=$("#question-form");
			var options=setOptions({
				submitHandler: function() {
					sendFunction();
				},
				rules:{
					content:{
						required:true,
						minlength:form.data("min-char")/1,
						maxlength:form.data("max-char")/1
					},
					"questionReceiver":{
						required:true
					}
				},
				messages:{
					content:{
						required:"Podaj treść pytania",
						minlength:form.data("min-text"),
						maxlength:form.data("max-text")
					},
					"questionReceiver":{
						required:"Wybierz typ pytania"
					}
				}
			});
			form.validate(options);
		},
		answer:function(params){
			var form=params.form;
			var options=setOptions({
				submitHandler: function() {
					params.success();
				},
				rules:{
					content:{
						required:true,
						minlength:form.data("min-char")/1,
						maxlength:form.data("max-char")/1
					}
				},
				messages:{
					content:{
						required:"Podaj treść odpowiedzi",
						minlength:form.data("min-text"),
						maxlength:form.data("max-text")
					}
				}
			});
			form.validate(options);
		},
		comment:function(params){
			var form=params.form;
			var options=setOptions({
				submitHandler: function() {
					params.success();
				},
				rules:{
					content:{
						required:true,
						minlength:form.data("min-char")/1,
						maxlength:form.data("max-char")/1
					}
				},
				messages:{
					content:{
						required:"Podaj treść komentarza",
						minlength:form.data("min-text"),
						maxlength:form.data("max-text")
					}
				}
			});
			form.validate(options);
		},
		rodoForm: function(sendFunction){
			var form = $('#rodo');
			var options = setOptions({
				submitHandler: function(form) {
					sendFunction($(form));
				},
				rules:{
					firstName: rules.firstname,
					surname: rules.surname,
					newFirstName: rules.firstname,
					newSurname: rules.surname,
					pesel:{
						pesel: true
					},
					email:{
						email: true
					},
					newEmail:{
						email: true
					},
					phone:{
						phone: true
					},
					newPhone:{
						phone: true
					},
					zipCode: {
						zipCode: true
					},
					newZipCode: {
						zipCode: true
					},
					city:{
						city:true
					},
					newCity:{
						city:true
					},
					street: {
						maxlength: 60,
						street: true
					},
					houseNumber: {
						maxlength: 10,
						houseNumber: true
					},
					flatNumber: {
						maxlength: 10,
						flat: true
					},
					newStreet: {
						maxlength: 60,
						street: true
					},
					newHouseNumber: {
						maxlength: 10,
						houseNumber: true
					}
				},
				messages: {
					firstName: messages.firstname,
					surname: messages.surname,
					newFirstName: messages.firstname,
					newSurname: messages.surname
				}
			});
			form.validate(options);
			if(form.find('label.error').length){
				$.scrollTo(form.find('label.error:first').offset().top-200,0);
			}
		},
		sendOnDeviceForm: function(sendFunction) {
			var options = setOptions({
				submitHandler: function(form) {
					sendFunction(form);
				},
				rules: {
					"cms_input_email": rules.email,
					"g-recaptcha-response": rules.recaptcha
				},
				messages: {
					"cms_input_email": messages.email,
					"g-recaptcha-response": messages.recaptcha
				}
			});
			$('#send-on-device-form').validate(options);
		},
		limitedService: function(sendFunction){
			var options=setOptions({
				submitHandler: function(form) {
					sendFunction(form);
				},
				rules:{
					"zipCode": rules.zipCode,
					"cityName": rules.city
				},
				messages:{
					"zipCode": messages.zipCode,
					"cityName": messages.city
				}
			});
			$("#limited-service-box form").validate(options);
		},
		newsletter:function(){
			var options=setOptions({
				rules:{
					"email": rules.email
				},
				messages:{
					"email": messages.email
				}
			});
			$("#footer-newsletter form").validate(options);
		},
		passwordRecovery:function(sendFunction){
			var options=setOptions({
				submitHandler: function(form) {
					sendFunction(form);
				},
				rules:{
					"email": rules.email,
					"g-recaptcha-response": rules.recaptcha
				},
				messages:{
					"email": messages.email,
					"g-recaptcha-response": messages.recaptcha
				}
			});
			$("#password-recovery form").validate(options);
		},
		loginView:function(sendFunction){
			var options=setOptions({
				submitHandler: function(form) {
					sendFunction();
				},
				rules:{
					"j_username": rules.email,
					"j_password": rules.password,
					"captcha": rules.captcha,
					"g-recaptcha-response" : rules.recaptcha
				},
				messages:{
					"j_username": messages.email,
					"j_password": messages.password,
					"captcha": messages.captcha,
					"g-recaptcha-response" : messages.recaptcha
				}
			});
			$("#loginView-login").validate(options);
		},
		registerLayer:function(sendFunction){
			var options = setOptions({
				submitHandler: function(){
					sendFunction();
				},
				rules:{
					nick: rules.nick,
					firstname: rules.firstname,
					surname: rules.surname,
					email: rules.email,
					password: rules.strongPassword,
					password2: rules.passwordNewRepeat,
					statuteAccepted : rules.termsAccepted,
					"g-recaptcha-response" : rules.recaptcha
				},
				messages:{
					nick: messages.nick,
					firstname: messages.firstname,
					surname: messages.surname,
					email: messages.email,
					password2: messages.passwordNewRepeat,
					statuteAccepted : messages.termsAccepted,
					"g-recaptcha-response" : messages.recaptcha
				}
			});
			$("#loginView-register").validate(options);
		},
		remindView:function(sendFunction){
			var options=setOptions({
				submitHandler: function(form) {
					sendFunction();
				},
				rules:{
					"email": rules.email,
					"g-recaptcha-response": rules.recaptcha
				},
				messages:{
					"email": messages.email,
					"g-recaptcha-response": messages.recaptcha
				}
			});
			$("#loginView-remind").validate(options);
		},
		login:function(sendFunction){
			var $form=$("#login-box form");
			var options=setOptions({
				rules:{
					"j_username": rules.login,
					"j_password": rules.password,
					"captcha": rules.captcha,
					"g-recaptcha-response": rules.recaptcha
				},
				messages:{
					"j_username": messages.login,
					"j_password": messages.password,
					"captcha": messages.captcha,
					"g-recaptcha-response": messages.recaptcha
				},
				errorPlacement: function(error, element){
					element.closest("form").find(".all-errors").append(error);
				},
				submitHandler: function(){
					sendFunction($form);
				}
			});
			$form.validate(options);
		},
		registration:function(sendFunction){
			var $form = $("#registration-box form");
			var options=setOptions({
				rules:{
					"firstname": rules.firstname,
					"surname": rules.surname,
					"email": rules.email,
					"password": rules.strongPassword,
					"password2": rules.passwordNewRepeat,
					"statuteAccepted":rules.termsAccepted
				},
				messages:{
					"firstname": messages.firstname,
					"surname": messages.surname,
					"email": messages.email,
					"password2": messages.passwordNewRepeat,
					"statuteAccepted":messages.termsAccepted
				},
				submitHandler: function(){
					sendFunction($form);
				}
			});
			$form.validate(options);
		},
		changePassword: function(sendFunction) {
			var options=setOptions({
				rules:{
					"password1": rules.strongPassword,
					"password2": rules.passwordNewRepeat
				},
				messages:{
					"password2": messages.passwordNewRepeat
				},
			});
			$("#change-password form").validate(options);
		},
		obligatoryChangePassword: function(sendFunction) {
			var options = setOptions({
				submitHandler: function() {
					sendFunction();
				},
				rules: {
					"password": rules.strongPassword,
					"currentPassword": rules.passwordOld,
					"confirmedPassword": rules.passwordNewRepeat
				},
				messages: {
					"currentPassword": messages.passwordOld,
					"confirmedPassword": messages.passwordNewRepeat
				},
			});
			$("#change-password form").validate(options);
		},
		cancelOrder: function(sendFunction) {
			var options=$.extend(true,defaults,{
				submitHandler: function(form) {
					sendFunction(form);
				},
				rules:{
					"cancelReasonOther": rules.cancelReasonOther
				},
				messages:{
					"cancelReasonOther": messages.cancelReason
				}
			});
			$('#cancel-reason-form').validate(options);
		},
		questionnaire: function(sendFunction) {
			var options=setOptions({
				submitHandler: function(form) {
					if($(form).valid()){
						sendFunction();
					}
				},
				rules:{
					"birthday": rules.birthday,
					"zipCode": rules.zipCode,
					"interestsCount": rules.interestsCount,
					"favouriteCategoriesCount": rules.favouriteCategoriesCount
				},
				messages:{
					"birthday": messages.birthday,
					"zipCode": messages.zipCode,
					"interestsCount": messages.interestsCount,
					"favouriteCategoriesCount": messages.favouriteCategoriesCount
				}
			});
			$("#questionnaire-form").validate(options);
		},
		invoice:function(params){
			var options=setOptions({
				submitHandler: function(form) {
					params.sendFunction(form);
				},
				rules:{
					"firstName": rules.firstname,
					"surname": rules.surname,
					"companyName": rules.companyName,
					"nip": rules.nip,
					"zipCode": rules.zipCode,
					"city": rules.city,
					"street": rules.street,
					"houseNumber": rules.houseNumber,
					"flatNumber": rules.flat
				},
				messages:{
					"firstname": messages.firstname,
					"surname": messages.surname,
					"companyName": messages.companyName,
					"nip": messages.nip,
					"zipCode": messages.zipCode,
					"city": messages.city,
					"street": messages.street,
					"houseNumber": messages.houseNumber,
					"flatNumber": messages.flat
				}
			});
			$("#invoice-form").validate(options);
			if(params.frontUserType!="COMPANY"){
				$("#nip").rules("remove", "required");
			}
		},
		basket:function(){
			var options=setOptions({
				rules:{
					"deliveryType": rules.deliveryType,
					"voucherData.code": rules.voucherCode
				},
				messages:{
					"deliveryType": messages.deliveryType,
					"voucherData.code": messages.voucherCode
				}
			});
			$("#basket #container form:eq(0)").validate(options);
		},
		complaintForm:function(sendFunction){
			var options=setOptions({
				submitHandler: function() {
					sendFunction();
				},
				rules:{
					"phoneNumber": rules.notRequiredPhone,
					"complaintReasonLabel": rules.complaintReason,
					"complaintDescription": rules.complaintDescription
				},
				messages:{
					"phoneNumber": messages.phone,
					"complaintReasonLabel": messages.complaintReason,
					"complaintDescription": messages.complaintDescription
				}
			});
			$("#complaint-form").validate(options);
		},
		userDataDelete:function(){
			var options=setOptions({
				rules:{
					"confirmDeleteAccount": {
						required:true
					}
				},
				messages:{
					"confirmDeleteAccount":  {
						required:"Usunięcie konta wymaga potwierdzenia"
					}
				}
			});
			$("#remove-account-form").validate(options);
		},
		userDataDate:function(){
			var options=setOptions({
				rules:{
					"dateOfBirth": {
						dateISO:true,
						date1900: true,
						agreementDateOfBirth: $('#date-form #date').data('agreementDateOfBirth')
					}
				},
				messages:{
					"dateOfBirth":  {
						dateISO:"Podaj poprawną datę urodzin"
					}
				}
			});
			$("#date-form").validate(options);
		},
		userDataEmail:function(){
			var options=setOptions({
				rules:{
					"emailNew": rules.email,
					"emailNewRepeat": rules.emailRepeat
				},
				messages:{
					"emailNew": messages.email,
					"emailNewRepeat": messages.emailRepeat
				}
			});
			$("#email-form").validate(options);
		},
		userDataPassword:function(){
			var options=setOptions({
				rules:{
					"passwordNew": rules.strongPassword,
					"passwordOld": rules.passwordOld,
					"passwordNewRepeat": rules.passwordNewRepeat
				},
				messages:{
					"passwordOld": messages.passwordOld,
					"passwordNewRepeat": messages.passwordNewRepeat
				}
			});
			$("#password-form").validate(options);
		},
		userDataAddress:function(){
			var form=$("#address-form");
			var options=setOptions({
				rules:{
					"firstName": rules.firstname,
					"surname": rules.surname,
					"frontUserType": rules.userType,
					"phone": rules.notRequiredPhone,
					"nip": rules.nip,
					"companyName": rules.companyName,
					"homeAddress.zipCode": {
						zipCode: true
					},
					"homeAddress.city": {
						maxlength: 40,
						city: true
					},
					"homeAddress.street": {
						minlength: 2,
						maxlength: 60,
						street: true
					},
					"homeAddress.houseNumber": {
						maxlength: 10,
						houseNumber: true
					},
					"homeAddress.flatNumber": rules.flat
				},
				messages:{
					"firstName": messages.firstname,
					"surname": messages.surname,
					"frontUserType": messages.userType,
					"phone": messages.phone,
					"nip": messages.nip,
					"companyName": messages.companyName,
					"homeAddress.zipCode": messages.zipCode,
					"homeAddress.city": messages.city,
					"homeAddress.street": messages.street,
					"homeAddress.houseNumber": messages.houseNumber,
					"homeAddress.flatNumber": messages.flat
				}
			});
			form.validate(options);
		},
		opinionEdit:function(sendFunction){
			var $form=$("#opinion-edit-form");
			var titleMaxLength = $form.find('#customer-opinion-edit-title').attr("maxlength");
			var contenMinLength = $form.find('#opinion-content-min-characters').val();
			var contenMaxLength = $form.find('#customer-opinion-edit-content').attr("maxlength");
			var options=setOptions({
				submitHandler: function() {
					sendFunction();
				},
				rules:{
					"title": {
						required: true,
						minlength: 2,
						maxlength: titleMaxLength
					},
					"content": {
						required: true,
						minlength: contenMinLength,
						maxlength: contenMaxLength
					}
				},
				messages:{
					"title": {
						required: 'Podaj tytuł opinii',
						minlength: `Podaj przynajmniej ${declinationOfZnak(2)}`,
						maxlength: `Podaj maksymalnie ${declinationOfZnak(titleMaxLength)}`
					},
					"content": {
						required: 'Podaj treść opinii',
						minlength: `Podaj przynajmniej ${declinationOfZnak(contenMinLength)}`,
						maxlength: `Podaj maksymalnie ${declinationOfZnak(titleMaxLength)}`
					}
				}
			});
			$form.validate(options);
		},
		questionEdit:function(sendFunction){
			var form=$("#question-edit-form");
			var options=setOptions({
				submitHandler: function() {
					sendFunction();
				},
				rules:{
					"content": rules.questionEdit
				},
				messages:{
					"content": messages.questionEdit
				}
			});
			form.validate(options);
		},
		answerEdit:function(sendFunction){
			var form=$("#answer-edit-form");
			var options=setOptions({
				submitHandler: function() {
					sendFunction();
				},
				rules:{
					"content": rules.answerEdit
				},
				messages:{
					"content": messages.answerEdit
				}
			});
			form.validate(options);
		},
		payment:function(){
			var options=setOptions({
				rules:{
					'paymentType': rules.paymentType,
					'instalmentBank': rules.ePaymentBank,
					'eTransferBankId': rules.ePaymentBank,
					'frontUser.pesel': rules.pesel,
					'instalmentShopCode': rules.shopCode,
					'instalmentCityCode': rules.cityCode,
					'termsAccepted': rules.termsAccepted,
					'giftCardNumber': rules.giftCardNumber,
					'giftCardPin': rules.giftCardPin,
					"deliveryTimeAccepted": {
						required: true
					}
				},
				messages:{
					'paymentType': messages.paymentType,
					'instalmentBank': messages.ePaymentBank,
					'eTransferBankId': messages.ePaymentBank,
					'frontUser.pesel': messages.pesel,
					'instalmentShopCode': messages.shopCode,
					'instalmentCityCode': messages.cityCode,
					'termsAccepted': messages.termsAccepted,
					'giftCardNumber': messages.giftCardNumber,
					'giftCardPin': messages.giftCardPin,
					"deliveryTimeAccepted": "Przed potwierdzeniem Zamówienia/rezerwacji zaakceptuj termin realizacji"
				},
				errorPlacement: function(error, element) {
					$('#gift-card-payment-box').removeClass('gift-card-not-submitted');
					defaults.errorPlacement(error, element);
				}
			});
			$("#payment #container form:eq(0)").validate(options);
		},
		changePayment: function(params){
			var options=setOptions({
				rules:{
					"deliveryInterval": {required:true},
					"ePaymentBankId": {required: true},
					"termsAccepted": {required: true},	// formularz jest dla "zmiany płatności" ale także dla ścieżki negatywnej PAYy i tam jest inne pole na zgody
					"advanceSaleDeliveryTermsAccepted": {required: true},
					"paymentOperatorAgreementAccepted": {required: true}
				},
				messages:{
					"deliveryInterval": "Wybierz dzień i przedział godzinowy",
					"ePaymentBankId": "Wybierz bank",
					"termsAccepted": "Wybór sposobu płatności wymaga akceptacji regulaminu",
					"advanceSaleDeliveryTermsAccepted": "Wybór sposobu płatności wymaga akceptacji terminu realizacji",
					"paymentOperatorAgreementAccepted": "Wybór sposobu płatności wymaga akceptacji regulaminu",
				},
				submitHandler: function(form) {
					params.send();
				},
			});
			params.$form.validate(options);
		},
		deliveryTime:function(){
			var form = $("#delivery-time #container form:eq(0)");
			var defaultSuccess = defaults.success;
			var defaultErrorPlacement = defaults.errorPlacement;
			var defaultInvalidHandler = defaults.invalidHandler;
			var options=setOptions({
				rules:{
					"deliveryTimeAccepted": {
						required: true
					},
					"deliveryTimeGroup": rules.deliveryTimeGroup,
					"interval": rules.interval,
					"termsAccepted": rules.termsAccepted,
					"deliveryCostAccepted": rules.deliveryCostAccepted,
					'paymentType': rules.paymentType,			//wszystkie poniższe dotyczą dodatkowej płatności na K5
					'instalmentBank': rules.ePaymentBank,
					'eTransferBank': rules.ePaymentBank,
					'frontUser.pesel': rules.pesel,
					'instalmentShopCode': rules.shopCode,
					'instalmentCityCode': rules.cityCode,
					'termsAccepted': rules.termsAccepted,
					'supplementPaymentType': { required: true }
				},
				messages:{
					"deliveryTimeAccepted": "Przed potwierdzeniem Zamówienia/rezerwacji zaakceptuj termin realizacji",
					"deliveryTimeGroup": messages.deliveryTimeGroup,
					"termsAccepted": messages.termsAccepted,
					"deliveryCostAccepted": messages.deliveryCostAccepted,
					'paymentType': messages.paymentType,		//wszystkie poniższe dotyczą dodatkowej płatności na K5
					'instalmentBank': messages.ePaymentBank,
					'eTransferBank': messages.ePaymentBank,
					'frontUser.pesel': messages.pesel,
					'instalmentShopCode': messages.shopCode,
					'instalmentCityCode': messages.cityCode,
					'termsAccepted': messages.termsAccepted,
					'supplementPaymentType': { required: 'Wybierz sposób płatności' }
				},
				/*
				 * Formularz wyboru terminu dostawy posiada zagnieżdżone radio buttony (wszystkie zagnieżdzone mają ten sam name), przez co domyślny mechanizm
				 * dodawania etykiet z błędami nie działa prawidłowo. Funkcje success i errorPlacement zostały nadpisane, aby w przypadku walidacji zagnieżdżonego
				 * pola radio button do formularza dodawana była klasa ujawniająca komunikaty błędów pod każdą podgrupą radio buttonów.
				 */
				success:function(label){
					if (label.prop("id") === "interval-error") {
						form.removeClass("invalid-interval");
					} else {
						defaultSuccess(label);
					}
				},
				errorPlacement:function(error, element) {
					if (error.prop("id") === "interval-error") {
						form.addClass("invalid-interval");
					} else {
						defaultErrorPlacement(error, element);
					}
				},
				invalidHandler: function(form, validator) {
					var deliveryGroup = $(form.target).find(".js-delivery-group:checked");
					if($(validator.errorList[0].element).hasClass("js-delivery-item") && deliveryGroup.length) {
						$.scrollTo(deliveryGroup.parent());
					} else {
						defaultInvalidHandler(form, validator);
					}
				}
			});
			form.validate(options);
		},
		chooseDelivery: function (deliveryType) {
			var options=setOptions({
				rules:{
					"orderUser.firstname": rules.firstname,
					"orderUser.surname": rules.surname,
					"orderUser.frontUserType": rules.userType,
					"orderUser.companyName": rules.companyName,
					"orderUser.email":rules.email,
					"orderUser.account.password": rules.passwordRegistration,
					"orderUser.account.password2": rules.passwordNewRepeat,
					"orderUser.homeAddress.street": rules.street,
					"orderUser.homeAddress.houseNumber": rules.houseNumber,
					"orderUser.homeAddress.flatNumber": rules.flat,
					"orderUser.homeAddress.zipCode": rules.zipCode,
					"orderUser.homeAddress.city": rules.city,

					"insurance.pesel": rules.pesel,
					"orderUser.nip": rules.nip,
					"orderUser.phone": rules.phone,

					"receiver.firstName": rules.firstname,
					"receiver.surname": rules.surname,
					"receiver.phone": rules.phone,
					"deliveryAddress.street":  rules.street,
					"deliveryAddress.houseNumber":  rules.houseNumber,
					"deliveryAddress.flatNumber":  rules.flat,
					"deliveryAddress.zipCode":  rules.zipCode,
					"deliveryAddress.city":  rules.city,

					"invoice.firstName":  rules.firstname,
					"invoice.surname":  rules.surname,
					"invoice.companyName": rules.companyName,
					"invoice.nip": rules.nip,
					"invoice.street": rules.street,
					"invoice.houseNumber": rules.houseNumber,
					"invoice.flatNumber": rules.flat,
					"invoice.zipCode": rules.zipCode,
					"invoice.city": rules.city,

					"termsAccepted": rules.termsAccepted,

					"delivery.shopCode": rules.shopCode,
					"delivery.cityCode": rules.cityCode,
					"delivery.localization": { required: true },
					"delivery.parcelMachineCode": rules.parcelMachineCode,
					"delivery.pickupPointForm.dhlParcelPointCode": rules.dhlParcelPointCode,
					"delivery.pickupPointForm.postOfficeCode": rules.postOfficeCode,
					"pofficeZipCode": rules.pofficeZipCode,
					"poffice": rules.poffice,

					"deliveryTimeAccepted": {required:true},

					"partnerSubscriptionsContactDetails.termsAccepted": {required:true},
					"partnerSubscriptionsContactDetails.firstName": rules.firstname,
					"partnerSubscriptionsContactDetails.lastName": rules.surname,
					"partnerSubscriptionsContactDetails.contactPhone": rules.phone
				},
				messages:{
					"orderUser.firstname": messages.firstname,
					"orderUser.surname": messages.surname,
					"orderUser.frontUserType":messages.userType,
					"orderUser.companyName": messages.companyName,
					"orderUser.email":messages.email,
					"orderUser.account.password":messages.password,
					"orderUser.account.password2":"",
					"orderUser.homeAddress.street": messages.street,
					"orderUser.homeAddress.houseNumber": messages.houseNumber,
					"orderUser.homeAddress.flatNumber": messages.flat,
					"orderUser.homeAddress.zipCode": messages.zipCode,
					"orderUser.homeAddress.city": messages.city,
					"orderUser.nip": messages.nip,
					"orderUser.phone":messages.phone,

					"insurance.pesel": messages.pesel,

					"receiver.firstName":messages.firstname,
					"receiver.surname":messages.surname,
					"receiver.phone":messages.phone,
					"deliveryAddress.street": messages.street,
					"deliveryAddress.houseNumber": messages.houseNumber,
					"deliveryAddress.flatNumber": messages.flat,
					"deliveryAddress.zipCode": messages.zipCode,
					"deliveryAddress.city": messages.city,

					"invoice.firstName": messages.firstname,
					"invoice.surname": messages.surname,
					"invoice.companyName":messages.companyName,
					"invoice.nip":messages.nip,
					"invoice.street":messages.street,
					"invoice.houseNumber":messages.houseNumber,
					"invoice.flatNumber":messages.flat,
					"invoice.zipCode":messages.zipCode,
					"invoice.city":messages.city,

					"termsAccepted": messages.termsAccepted,

					"delivery.shopCode":messages.shopCode,
					"delivery.cityCode":messages.cityCode,
					"delivery.parcelMachineCode":messages.parcelMachineCode,
					"delivery.localization": { required: (deliveryType == 'inpost' ? "Użyj wyszukiwarki aby wybrać Paczkomat®" : "Użyj wyszukiwarki aby wybrać punkt odbioru ") },
					"delivery.pickupPointForm.dhlParcelPointCode": messages.dhlParcelPointCode,
					"delivery.pickupPointForm.postOfficeCode": messages.postOfficeCode,
					"pofficeZipCode": messages.pofficeZipCode,
					"poffice": messages.poffice,

					"deliveryTimeAccepted": {required: "Czas realizacji musi zostać zaakceptowany"},

					"partnerSubscriptionsContactDetails.firstName": messages.firstname,
					"partnerSubscriptionsContactDetails.lastName": messages.surname,
				}
			});
			$("#choose-delivery-form").validate(options);
			$('input[name^="insurance.insurerNameToReadStatus"]').each(function(index, element) {
				$(element).rules("add", {
					required: $(element).hasClass('subscription-regulation') ? rules.warrantySubscriptionRegulations : rules.warrantyRegulations,
					messages: $(element).hasClass('subscription-regulation') ? messages.warrantySubscriptionRegulations : messages.warrantyRegulations
				});
			});
		},
		giftCardDelivery:function() {
			var options=setOptions({
				rules:{
					"frontUser.firstname": rules.firstname,
					"frontUser.surname": rules.surname,
					"frontUser.phone": rules.phone,
					"termsAccepted": rules.termsAccepted
				},
				messages:{
					"frontUser.firstname": messages.firstname,
					"frontUser.surname": messages.surname,
					"frontUser.phone":messages.phone,
					"termsAccepted": messages.termsAccepted
				}
			});
			$('#choose-delivery-form').validate(options);
		},
		delivery:function(sendFunction){
			var options=setOptions({
				submitHandler: function(form) {
					sendFunction(form);
				},
				onkeyup: function(el) {
					var isFormValid = $('#delivery-form').valid();
					$('#delivery-save-btn').prop('disabled', !isFormValid);
				},
				rules:{

					"addLine1": rules.firstname,
					"addLine2": rules.surname,
					"zipCode": rules.zipCode,
					"city": rules.city,
					"street": rules.street,
					"houseNumber": rules.houseNumber,
					"flatNumber": rules.flat
				},
				messages:{
					"addLine1": messages.firstname,
					"addLine2": messages.surname,
					"zipCode": messages.zipCode,
					"city": messages.city,
					"street": messages.street,
					"houseNumber": messages.houseNumber,
					"flatNumber": messages.flat
				}
			});
			$('#delivery-form').validate(options);
		},
		receiver:function(sendFunction){
			var options=setOptions({
				submitHandler: function(form) {
					sendFunction(form);
				},
				onkeyup: function(el) {
					var isFormValid = $('#receiver-form').valid();
					$('#receiver-save-btn').prop('disabled', !isFormValid);
				},
				rules:{
					"firstName": rules.firstname,
					"lastName": rules.surname,
					"phone": rules.phone,
				},
				messages:{
					"firstName": messages.firstname,
					"lastName": messages.surname,
					"phone": messages.phone
				}
			});
			$('#receiver-form').validate(options);
		},
		giftCardOrderSelection:function(sendFunction){
			var $form = $('#front-form');
			var options=$.extend(true,defaults,{
				rules:{
					"value": rules.giftCardValue
				},
				messages:{
					"value": messages.giftCardValue
				}
			});
			$form.validate(options);
		}
	};

	var methods={
		firstname: function(value, element){
			// pierwsza litera jest dozwoloną literą
			// pozostałe 34 znaki mogą być literą, spacją i myślnikiem
			return /^[a-zA-ZąćęłńóśżźĄĆĘŁŃÓŚŻŹ']{1}[a-zA-ZąćęłńóśżźĄĆĘŁŃÓŚŻŹ\- ']{1,39}$/.test(value) && !/.[\s]{2,}/.test(value) && !/.[-]{2,}/.test(value);
		},
		surname: function(value, element){
			// pierwsza litera jest dozwoloną literą
			// pozostałe 34 znaki mogą być literą, spacją i myślnikiem
			return /^[a-zA-ZąćęłńóśżźĄĆĘŁŃÓŚŻŹ']{1}[a-zA-ZąćęłńóśżźĄĆĘŁŃÓŚŻŹ\- ']{1,39}$/.test(value) && !/.[\s]{2,}/.test(value) && !/.[-]{2,}/.test(value);
		},
		pesel:function(value, element){
			var status=true;
			var pesel = value.replace(/[\ \-]/gi, "");
			if (pesel.length != 11) {
				status = false;
			} else {
				var steps = new Array(1, 3, 7, 9, 1, 3, 7, 9, 1, 3);
				var sum_nb=0;
				var sum_c=0;
				for (var x = 0; x < 10; x++) {
					sum_nb += steps[x] * pesel.charAt(x);
				}
				var sum_m = 10 - sum_nb % 10;
				if (sum_m != 10) {
					sum_c = sum_m;
				}
				if (sum_c != pesel.charAt(10)) {
					status = false;
				}
			}
			return status;
		},
		phone:function(value, element){
			var number = value + '';
			var numberValue = number.match(/\d/g);
			if(numberValue!== null && numberValue.length === 9){
				return true;
			}
		},
		street:function(value, element){
			var testReg1 = new RegExp("^[0-9a-zA-ZąćęłńóśżźĄĆĘŁŃÓŚŻŹ\\- .']{2,60}$");	//dozwolone znaki
			var testReg2 = new RegExp("[a-zA-ZąćęłńóśżźĄĆĘŁŃÓŚŻŹ]+");					//min jedna litera
			return testReg1.test(value) && testReg2.test(value);
		},
		zipCode:function(value, element){
			var status = true;
			var zipCode = value.replace(/[\ \-]/gi, "");
			if(/\d{5}/.test(zipCode) && zipCode.length >= 5) {
				$(element).val(zipCode.substr(0,2)+"-"+zipCode.substr(2,3));
			}else{
				status = false;
			}
			return status;
		},
		city:function(value, element){
			return /^[a-zA-ZąćęłńóśżźĄĆĘŁŃÓŚŻŹ\- .]{2,40}$/.test(value);
		},
		houseNumber:function(value, element){
			if (value.length > 10) {
				return false;
			} else if (/\d/.test(value) && !/;/.test(value) && /^[^\-].*/.test(value)) {	// min 1 cyfra, brak średnika, nie zaczyna się od "-"
				return true;
			}
			return false;
		},
		flat:function(value, element){
			if (value.length > 10) {
				return false;
			} else if (!/;/.test(value) && /^[^\-].*/.test(value)) {	// brak średnika, nie zaczyna się od "-"
				return true;
			}
			return false;
		},
		datePL:function(value, element){
			var check = false;
			if( /^\d{1,2}-\d{1,2}-\d{4}$/.test(value)){
				var dateTable = value.split('-');
				var dd = parseInt(dateTable[0],10);
				var mm = parseInt(dateTable[1],10);
				var rrrr = parseInt(dateTable[2],10);
				var xdata = new Date(rrrr,mm-1,dd);
				if ( ( xdata.getFullYear() == rrrr ) && ( xdata.getMonth () == mm - 1 ) && ( xdata.getDate() == dd ) ){
					check = true;
				}else{
					check = false;
				}
			} else{
				check = false;
			}
			return  check;
		},
		dowodOsobisty:function(value, element){
			var numer=value+'';
			numer=numer.match(/[A-Za-z0-9]/gi).join('').toUpperCase();

			if (numer === '' || numer.length !== 9){
				return false;
			}

			var letterValues = [ '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A',
					'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N',
				'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
			];

			function getLetterValue(letter) {
				for (j = 0; j < letterValues.length; j++)
					if (letter == letterValues[j])
						return j;
				return -1;
			}

			// Check seria
			for (i = 0; i < 3; i++)
				if (getLetterValue(numer[i]) < 10)
					return false;
			// Check number
			for (i = 3; i < 9; i++)
				if (getLetterValue(numer[i]) < 0 || getLetterValue(numer[i]) > 9)
					return false;

			// sprawdz cyfre controlna
			sum = 7 * getLetterValue(numer[0]) + 3 * getLetterValue(numer[1]) + 1 *
				getLetterValue(numer[2]) + 7 * getLetterValue(numer[4]) + 3 *
				getLetterValue(numer[5]) + 1 * getLetterValue(numer[6]) + 7 *
				getLetterValue(numer[7]) + 3 * getLetterValue(numer[8]);
			sum %= 10;
			if (sum != getLetterValue(numer[3])){
				return false;
			}
			return true;
		},
		dateMax:function(value,element,param){
			var t=value.split('-');
			var y=param.split('-');
			var status=(new Date(y[1]+'/'+y[0]+'/'+y[2]) >= new Date(t[1]+'/'+t[0]+'/'+t[2]));
			return status;
		},
		dateMin:function(value,element,param){
			var t=value.split('-');
			var y=param.split('-');
			var status=(new Date(y[1]+'/'+y[0]+'/'+y[2]) <= new Date(t[1]+'/'+t[0]+'/'+t[2]));
			return status;
		},
		dateLowestRange:function(value,element){
			var t=$(element).val().split('-');
			var status=(new Date('01/01/1900') <= new Date(t[1]+'/'+t[0]+'/'+t[2]));
			return status;
		},
		nip:function(value,element){
			function nipValidator(nip){
				var verificator_nip = new Array(6,5,7,2,3,4,5,6,7);
				var n = 0;
				var ile;
				for (var i=0; i<9; i++) {
					ile=nip.charAt(i)/1 * verificator_nip[i]/1;
					n += ile;
				}
				// walidacja odrzuca nip z samymi zerami
				if (n === 0) {
					return false;
				}
				n %= 11;
				if (n != nip.charAt(9)) {
					return false;
				}else{
					return true;
				}
			}
			var status=false;
			if(jQuery(element).val()===""){
				status=true;
			} else{
				var nip = value.replace(/[\ _\-]/gi, "");
				if(/\d{3}-\d{2}-\d{2}-\d{3}/.test(value) || /\d{3}-\d{3}-\d{2}-\d{2}/.test(value) || /\d{10}/.test(value)){
					status=true;
					if (nip.length != 10) {
						status = false;
					} else {
						status=nipValidator(nip);
						if(status===true && !/\d{3}-\d{3}-\d{2}-\d{2}/.test(value)){
							jQuery(element).val(nip.substr(0,3)+"-"+nip.substr(3,2)+"-"+nip.substr(5,2)+"-"+nip.substr(7,3));
						}
					}
				}else{
					status=false;
				}
			}
			return status;
		},
		trim:function (value,element) {
			return $.trim(value) ? true : false;
		},
		voucherCode: function(value, element) {
			if (value.length==0 || /^[0-9a-zA-Z.-]+$/.test(value) ) {
				return true;
			}
			return false;
		},
		money:function(value,element){
			if(/^([1-9][0-9]*|0)((\.|\,)[0-9]{2})?$/.test(value) && parseInt(value) <= 999999){
				return true;
			}
			return false;
		},
		companyName:function(value,element){
			var result = value.split('').filter(function (y) {
				let char = y.charCodeAt();
				return char > 20 && char < 383;
			});
			return result.length == value.length;
		},
        phoneMask:function(value){
            var number = value + '';
            if (number.indexOf('_') === -1){
                return true;
            }
            return false;
        },
        requiredPhoneMask:function(value){
            var number = value + '';
            if ((number.match(/_/g) || []).length < 9){
                return true;
            }
            return false;
        },
		childBenefit:function(value, element, params) {
			var $childBenefit = $(element);
			var $dependantsNumber = $('#dependants-number');
			var v1= $dependantsNumber.val() || "";
			var v2 = $childBenefit.val() || "";
			var child = v1 > 0 ? params.dependantsNumbers.filter(function(item){
				return item.value == v1;
			})[0].i : -1;
			var p500 =  v2 > 0 ? params.childBenefits.filter(function(item){
				return item.value == v2;
			})[0].i : -1;
			if(child != ''){
				if(child * 500 >= p500){
					return true;
				}
			}
			return false;
		},
		date1900: function (value, element) {
			var data=value.split('-');
			var today=new Date();
			var y= data[0]/1;
			var m = data[1]/1;
			var d = data[2]/1;
			var DOB = new Date(y,m-1,d, 0,0,0);
			var max = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
			if(y>1900 && y<=today.getFullYear() && m>0 && d>0 && DOB < max) {
				return true;
			}
			return false;
		},
		agreementDateOfBirth: function (value) {
			if (value.length == 0){
				return true;
			}
			var today=new Date();
			var data=value.split('-');
			var y = data[0]/1;
			var m = data[1]/1;
			var d = data[2]/1;
			var selectedDateOfBirth = new Date(y,m-1,d, 0,0,0); //
			var minAgreementDateOfBirth = new Date(today.getFullYear()-16, today.getMonth(), today.getDate(), 0, 0, 0);
			if(selectedDateOfBirth <= minAgreementDateOfBirth) {
				return true;
			}
			return false;
		},
		userNick: function (value) {
			// regexp FE headlessowego
			// dopuszcza litery, cyfry, jedną spacje/myślnik/apostrof
			var rgexp = /^(?!(.* .*){2})(?!(.*'.*){2})(?!(.*-.*){2})[A-Za-zżźćńółęąśŻŹĆĄŚĘŁÓŃ0-9][A-Za-zżźćńółęąśŻŹĆĄŚĘŁÓŃ0-9 '-]+$/;
			if(rgexp.test(value)) {
				return true;
			}
			return false;
		},
		strongPassword: function() {
			return passwordInvalid.check();
		}
	};

	function declinationOfZnak(x){
		if (x == 1) {
			return x + ' znak';
		} else if ((x % 10 > 1 && x % 10 < 5) && !(x % 100 > 11 && x % 100 < 15)) {
			return x + ' znaki';
		} else {
			return x + ' znaków';
		}
	}
	function task(name,params){
		if(name && tasks[name]){
			tasks[name](params);
		}
	}
	function resetForm($form){
		$('textarea, input', $form).val('').trigger('change').removeClass('error');
		$('.validate-target', $form).removeClass('validate-error');
		$('label.error', $form).remove();
	}

	function removeBackendError($input) {
		$input.siblings('.error-backend').remove();
	}

	function invalidMessage(name){
		if (name.length && KLvalidateMessage && typeof KLvalidateMessage[name] !=="undefined" && KLvalidateMessage[name].invalid){
			return KLvalidateMessage[name].invalid;
		}else{
			return "Pole jest niepoprawne";
		}
	}

	function homeAddressNotEmpty(element) {
		var empty = true;
		$('input[name^=homeAddress]').each(function() {
			empty = (empty && !$(this).val());
		});
		return !empty;
	}

	function emptyMessage(name){
		if(name.length && typeof KLvalidateMessage[name] !=="undefined" && KLvalidateMessage[name].empty){
			return KLvalidateMessage[name].empty;
		}else{
			return "Pole jest wymagane";
		}
	}
	var KLvalidateMessage={};

	function setKLMessage(message){
		KLvalidateMessage=message;
	}

	function off($form){
		$form.find('input, select').ignore(true);
	}
	var addedMethods=[
		["firstname", "Imię zawiera niepoprawne znaki"],
		["surname", "Nazwisko zawiera niepoprawne znaki"],
		['city','Podaj poprawną nazwę miejscowości'],
		['nip','Podaj poprawny nip'],
		['phone','Podaj poprawny numer telefonu'],
		['street', 'Ulica zawiera niepoprawne znaki'],
		['zipCode','Podaj poprawny kod pocztowy'],
		['pesel','Podaj poprawny PESEL'],
		['voucherCode', 'Kod rabatowy zawieran niedozwolone znaki'],
		['trim','Pole nie może być wypełnione tylko spacjami'],
		['houseNumber','Podaj poprawny numer domu'],
		['flat','Podaj poprawny numer mieszkania'],
		['dowodOsobisty','Podaj poprawny numer dowodu osobistego'],
		['datePL','Format daty jest niepoprawny'],
		['money','Podaj poprawną kwotę'],
		['companyName', 'Nazwa firmy zawiera niepoprawne znaki'],
		['phoneMask','Podaj numer telefonu komórkowego w prawidłowym formacie: XXXXXXXXX'],
		['requiredPhoneMask','To pole jest wymagane'],
		['dateMax','Wybrana data jest niewłaściwa, maksymalna data to {0}'],
		['dateMin','Wybrana data jest niewłaściwa, minimalna data to {0}'],
		['dateLowestRange','Data nie może być wcześniejsza niż 01-01-1900'],
		['childBenefit','Wartość świadczenia 500+ jest niezgodna z liczbą dzieci na utrzymaniu'],
		['date1900','Zakres daty urodzin jest niewłaściwy'],
		['agreementDateOfBirth','Proszę o podanie wartości większej bądź równej {0}'],
		['userNick','Pole zawiera niepoprawne znaki (dopuszczalne to litery, cyfry oraz jeden myślnik, apostrof lub spacja)'],
		['strongPassword', false, true]
	];
	$(document).ready(function(){
		$(addedMethods).each(function(i,n){
			var fn=methods[n[0]];
			$.validator.addMethod(n[0], function (value, element, param) {
				if (n[2]) {
					return fn(value, element, param);
				} else {
					return this.optional(element) || fn(value, element, param);
				}
			}, n[1]);
		});
	});
	return {
		task: task,
		resetForm: resetForm,
		removeBackendError: removeBackendError,
		off:off,
		setKLMessage: setKLMessage,
		scrollToError: scrollToError
	};
});
